import { useState } from "react";
import FormSubmitButton from "./FormSubmitButton";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { setNotifTo } from "../../store";
import { addMessage } from "../../remote/firebase";

function ContactForm({ className }) {
  const dispatch = useDispatch();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const clear = () => {
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        addMessage(name, email, message);
        dispatch(
          setNotifTo(
            "Sent successfully!"
          )
        );
        clear();
      }}
      className={classNames("flex flex-col w-[93%] h-[400px] ml-1", className)}
    >
      <h1 className="text-white text-sm mt-2">I'd Love To Hear From You</h1>
      <div className="flex flex-col form-section w-5/6">
        <label htmlFor="name" className="form-label">
          Your Name
        </label>
        <input
          type="text"
          name="name"
          className="form-input"
          value={name}
          required
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
      </div>
      <div className="flex flex-col form-section w-5/6">
        <label htmlFor="email" className="form-label">
          Your Email
        </label>
        <input
          type="email"
          name="email"
          className="form-input"
          value={email}
          required
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
      </div>
      <div className="flex flex-col form-section grow">
        <label htmlFor="message" className="form-label">
          Message
        </label>
        <textarea
          name="message"
          className="form-input grow"
          value={message}
          onChange={(e) => {
            setMessage(e.target.value);
          }}
          placeholder="Hello there!"
        />
      </div>
      <div className="mt-2 flex flex-row items-center">
        <FormSubmitButton />
        <button
          type="button"
          className="ml-3 form-clear"
          onClick={(e) => {
            e.stopPropagation();
            clear();
          }}
        >
          Clear Form
        </button>
      </div>
    </form>
  );
}

export default ContactForm;
